module.exports = __webpack_public_path__ + "static/media/brand_tch_logo.1269a8ee.png";